<button
  *ngIf="!linkRouter && !href"
  class="navigation-button"
  [class.navigation-button--active]="isActive"
  type="button"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>

<a
  *ngIf="linkRouter && text"
  class="navigation-button"
  [class.navigation-button--active]="isActive"
  [routerLink]="linkRouter"
  [queryParams]="linkQueryParams"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>

<a
  *ngIf="href && text"
  class="navigation-button"
  [class.navigation-button--active]="isActive"
  [href]="href"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>

<a
  *ngIf="href && iconName && !text"
  app-vtmn-play-icon-button
  class="mx-2"
  [class.navigation-button--active]="isActive"
  [href]="href"
  [variant]="vtmnPlayIconButtonVariant.TERTIARY"
  [size]="vtmnPlayIconButtonSize.LARGE"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>

<ng-template #content>
  <vtmn-play-icon
    *ngIf="iconName && !text"
    class="navigation-button__icon-section__icon"
    [name]="iconName"
  ></vtmn-play-icon>

  <span
    *ngIf="(text && iconName) || totalNotifications"
    class="navigation-button__icon-section"
  >
    <vtmn-play-icon
      *ngIf="iconName"
      class="navigation-button__icon-section__icon"
      [name]="iconName"
    ></vtmn-play-icon>
    <span
      *ngIf="totalNotifications > 0"
      class="navigation-button__icon-section__notification"
    >
      {{ totalNotifications }}
    </span>
  </span>
  {{ text }}
</ng-template>
